import { render, staticRenderFns } from "./PluginQue.vue?vue&type=template&id=045975df&"
import script from "./PluginQue.vue?vue&type=script&lang=js&"
export * from "./PluginQue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports